import { Button, palette } from '@landr/maestro';
import styled from 'styled-components';

/* @maestro-no-token */
export const ButtonWithActiveStyle = styled(Button)`
    &[aria-pressed='true'] {
        background-color: ${palette('neutral.600')};
    }
`;
